<template>
  <div class="wrapper flex-row align-center full-parent">
    <div class="bg-block flex-column align-center justify-center">
      <img
        class="bg full-parent skeleton swiper-lazy"
        draggable="false"
        data-src="https://mm2015.mamalaile.com.cn/b3495fe00fb1b69ef2d317d6607fcec5.png"
      />
      <slideInfo
        title="开启你的舒心月子之旅吧#放心交给我们"
        subtitle="妈妈来了月子顾问很高兴为您服务！"
        desc="妈妈来了为您提供最专业，最齐全的育儿知识#提前找月嫂，月嫂多，档期全#妈妈来了小程序可查看月嫂资料及档期"
        :width="18"
        white
        buttonText="立即开启"
      />
    </div>

    <div class="stage-block">
      <div
        v-for="(item, index) of stageList"
        :key="index"
        class="stage-item flex-row justify-between"
      >
        <div class="title">{{ item.title }}</div>
        <div class="desc-block">
          <div
            v-for="(descItem, descIndex) of item.desc.split('#')"
            :key="descIndex"
            class="desc"
          >
            {{ descItem }}
          </div>
        </div>
      </div>
    </div>

    <div class="copyright">
      Copyright © 生活魔方（深圳）科技有限公司<a
        target="_blank"
        href="https://beian.miit.gov.cn/"
        >粤ICP备15084376号</a
      >
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

export default defineComponent({
  components: { slideInfo },

  data() {
    return {
      stageList: [
        { title: '孕中期', desc: '最快2小时可面试月嫂,视频面试/线下月嫂见面,协助您找到好月嫂#选定月嫂，支付定金即可开启妈妈来了团队服务#妈妈来了服务团队24小时在线服务，有问题随时咨询' },
        { title: '孕后期', desc: '临近生产，医护专家提供微信/电话指导，如待产包准备、生产前心理建设等' },
        { title: '生产前', desc: '进产房开6指前或剖腹产提前告知生产时间给团队，通知月嫂到岗开始服务#住院期间月嫂24小时陪护' },
        { title: '生产后', desc: '出院后，月嫂24小时住家服务，提供全面呵护#月子服务期间，售后团队24小时在线跟进，有问题可随时反馈' },
        { title: '月子期', desc: '月嫂对家人进行育儿技能传递，帮助新手家庭建立育儿信心#妈妈来了母乳指导团队线上、线下助力实现母乳喂养' },
        { title: '月子结束', desc: '月嫂服务结束,宝妈可对其服务做出评价#宝宝百日、1岁、2岁、3岁的生日关怀#幼儿理念传递' },
      ]
    };
  }
});
</script>


<style lang="less" scoped>
.wrapper {
  .bg-block {
    width: 42.81vw;
    height: 100%;
    position: relative;
    margin-right: 10.42vw;

    .bg {
      position: absolute;
      left: 0;
      top: 0;
      object-fit: cover;
    }
  }

  .stage-block {
    .stage-item {
      width: 34.27vw;
      padding: 1.51vw 0 1.56vw;
      border-bottom: solid rgba(160, 160, 160, 0.2) 1px;

      &:last-child {
        border-bottom: none;
      }

      .title {
        font-size: 1.04vw;
        line-height: 1.41vw;
        color: #303030;
        font-family: @font-ab;
      }

      .desc-block {
        width: 20.99vw;

        .desc {
          font-size: 0.73vw;
          line-height: 1.04vw;
          color: #303030;
          text-align: justify;
          margin-bottom: 0.5vw;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .copyright {
    @hr: 2.6vw;
    width: 100%;
    height: @hr;
    font-size: 0.73vw;
    line-height: @hr;
    background-color: #131415;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
    color: rgba(255, 255, 255, 0.7);
    text-align: center;

    a {
      color: inherit;
    }
  }
}
</style>